import React from 'react';

export const Loading = React.memo(() => (
  <p>Loading...</p>
));